const dict = {
  it: {
    "app.name": "TrustMaster Advisor",
    "app.tagline": "Gestionale contabile multi-entità",
    "nav.overview": "Panoramica",
    "nav.dashboard": "Dashboard Finanziaria",
    "nav.cashflow": "Flussi di Cassa",
    "nav.task": "Task",
    "nav.boards": "Bacheche",
    "boards.new": "Nuova Bacheca",
    "boards.name": "Nome Bacheca",
    "boards.open": "Apri",
    "boards.tasks": "task",
    "boards.setBg": "Imposta immagine di sfondo",
    "login.tabEmail": "Email + SMS OTP",
    "login.email": "Email",
    "login.password": "Password",
    "login.otp": "Codice OTP ricevuto via SMS",
    "login.continue": "Continua",
    "login.login": "Accedi",
    "login.verify": "Verifica e Accedi",
    "login.firstAccess": "Primo accesso: ti abbiamo inviato un codice SMS. Crea la tua password.",
    "login.newPassword": "Nuova Password (min. 8 caratteri)",
    "login.setupBtn": "Crea Password e Accedi",
    "login.forgot": "Password dimenticata?",
    "login.resetHelp": "Reset password: inserisci il codice ricevuto e scegli una nuova password.",
    "login.resetBtn": "Reimposta Password e Accedi",
    "login.otpSent": "Codice SMS inviato",
    "login.resend": "Invia di nuovo il codice SMS",
    "login.sentSms": "Codice inviato via SMS",
    "login.sentEmail": "Codice inviato via Email",
    "login.manualCode": "Inserisci il codice di accesso fornito dall'amministratore",
    "nav.users": "Utenti & Accessi",
    "users.add": "Nuovo Utente",
    "users.role": "Ruolo",
    "users.phone": "Telefono OTP (SMS)",
    "users.master": "Master",
    "users.admin": "Amministratore",
    "users.member": "Utente",
    "users.viewer": "Solo Bacheche",
    "task.assignees": "Assegnato a",
    "task.noUsers": "Nessun utente: creali in Utenti & Accessi",
    "task.onlyMine": "Solo i miei task",
    "task.assignedToYou": "Task assegnati a te",
    "users.pwdSet": "Password attiva",
    "users.pwdPending": "Primo accesso in attesa",
    "users.hint": "Il nuovo utente creerà la propria password al primo accesso, dopo verifica del codice SMS inviato al suo telefono.",
    "users.resetPwd": "Resetta password utente",
    "users.resetDone": "Password resettata: l'utente imposterà una nuova password al prossimo accesso (verifica OTP).",
    "users.accessCode": "Genera codice di accesso manuale",
    "users.accessCodeTitle": "Codice di accesso manuale (valido 10 minuti)",
    "users.accessCodeHelp": "Comunica questo codice all'utente a voce/WhatsApp. Nella pagina di login, dopo email (e password se già impostata), deve inserirlo come codice OTP.",
    "users.forbidden": "Accesso riservato a Master e Amministratori",
    "task.new": "Nuovo Task",
    "task.edit": "Modifica Task",
    "task.title": "Titolo",
    "task.assignee": "Assegnato a",
    "task.priority": "Priorità",
    "task.entity": "Entità",
    "task.members": "Collaboratori",
    "task.role": "Privilegi",
    "task.roleWrite": "Scrittura",
    "task.roleRead": "Solo Lettura",
    "task.low": "Bassa",
    "task.medium": "Media",
    "task.high": "Alta",
    "task.col.todo": "Da Fare",
    "task.col.doing": "In Corso",
    "task.col.review": "In Revisione",
    "task.col.done": "Completato",
    "nav.accounting": "Gestione Contabile",
    "nav.sales": "Fatture di Vendita",
    "nav.purchases": "Fatture di Acquisto",
    "nav.ledger": "Piano dei Conti & Prima Nota",
    "nav.reportsGroup": "Bilancio & Registri",
    "nav.reports": "Conto Economico & Bilancio",
    "nav.contacts": "Anagrafiche",
    "nav.services": "Articoli",
    "nav.legal": "Conformità & Legal",
    "nav.contracts": "Contrattualistica",
    "nav.compliance": "Antiriciclaggio & Privacy",
    "nav.vault": "Documenti d'Identità",
    "nav.integrations": "Integrazioni",
    "nav.connectors": "Connettori",
    "nav.emails": "Email",
    "nav.forms": "Modulistica",
    "forms.title": "Modulistica",
    "forms.subtitle": "Carica i tuoi modelli Word (con la tua carta intestata), compilali con i dati delle anagrafiche, genera il PDF e invialo via email o per firma DocuSign.",
    "forms.upload": "Carica Modello Word",
    "forms.name": "Nome modello",
    "forms.category": "Categoria",
    "forms.cat.contratto": "Contratti",
    "forms.cat.antiriciclaggio": "Antiriciclaggio",
    "forms.cat.privacy": "Privacy",
    "forms.file": "File .docx",
    "forms.templates": "Modelli caricati",
    "forms.noTemplates": "Nessun modello caricato: carica il tuo primo .docx",
    "forms.generate": "Genera",
    "forms.generateTitle": "Genera documento da modello",
    "forms.contact": "Cliente (anagrafica)",
    "forms.noContact": "— Nessuno / compilo a mano —",
    "forms.loadFields": "Carica campi",
    "forms.fields": "Campi del modello (precompilati dall'anagrafica, modificabili)",
    "forms.generatePdf": "Genera PDF",
    "forms.generatedOk": "Documento PDF generato e archiviato",
    "forms.archive": "Documenti Generati",
    "forms.noDocs": "Nessun documento generato per questa entità",
    "forms.download": "Scarica PDF",
    "forms.email": "Invia Email",
    "forms.docusign": "Invia per firma",
    "forms.signerName": "Nome firmatario",
    "forms.signerEmail": "Email firmatario",
    "forms.docusignSent": "Busta DocuSign inviata al firmatario",
    "forms.status.generated": "Generato",
    "forms.status.emailed": "Inviato via email",
    "forms.status.docusign_sent": "In firma (DocuSign)",
    "forms.sync": "Aggiorna stato firma",
    "forms.uploadOk": "Modello caricato",
    "forms.placeholdersFound": "Segnaposto rilevati nel modello",
    "forms.tabAll": "Tutti",
    "forms.docsTab": "Modelli e documenti",
    "forms.records": "Registro",
    "forms.or": "oppure",
    "forms.newHtml": "Nuovo modello con editor",
    "forms.editHtml": "Modifica modello",
    "forms.kind.html": "Editor",
    "forms.insertPlaceholder": "Inserisci segnaposto…",
    "forms.letterhead": "Carta intestata automatica (nome entità e dati fiscali)",
    "forms.saveTemplate": "Salva modello",
    "forms.addDefaults": "Aggiungi modelli predefiniti (contratto, AML, privacy)",
    "forms.defaultsAdded": "Modelli predefiniti aggiunti",
    "forms.defaultsExist": "I modelli predefiniti sono già presenti",
    "forms.preview": "Anteprima PDF",
    "forms.emailPreview": "Anteprima email al cliente",
    "forms.emailBodyHint": "Lascia vuoto per usare il testo standard. Puoi usare {{entita}}, {{data}}.",
    "forms.dualSign": "Firma anche l'entità (secondo firmatario, dopo il cliente)",
    "forms.secondSignerName": "Nome firmatario entità",
    "forms.secondSignerEmail": "Email firmatario entità",
    "forms.dualSignHint": "Il cliente firma per primo; poi DocuSign invia la busta al firmatario dell'entità.",
    "dash.signatures": "Firme DocuSign",
    "dash.noSignatures": "Nessuna nuova firma: lo stato delle buste viene aggiornato ogni ora.",
    "dash.sig.docusign_completed": "Firmato",
    "dash.sig.docusign_declined": "Rifiutato",
    "dash.sig.docusign_voided": "Annullato",
    "dash.markRead": "Segna come letto",
    "dash.sig.docusign_reminder": "Sollecito",
    "notif.title": "Notifiche",
    "notif.empty": "Nessuna notifica per questa entità",
    "notif.docExpired": "Documento scaduto",
    "notif.taskOverdue": "Task in ritardo dal",
    "notif.taskDue": "Task in scadenza il",
    "task.comments": "Commenti",
    "task.addComment": "Scrivi un commento…",
    "task.send": "Invia",
    "task.noComments": "Nessun commento",
    "task.dragHint": "Trascina le card tra le colonne",
    "notif.docExpiring": "Scade tra",
    "notif.invoiceOverdue": "Fattura scaduta il",
    "forms.remind": "Invia sollecito firma",
    "forms.remindOk": "Sollecito inviato al firmatario",
    "forms.signedCopy": "Copia firmata archiviata nel Vault",
    "logo.title": "Logo per carta intestata",
    "logo.none": "Nessun logo",
    "logo.upload": "Carica logo",
    "logo.replace": "Sostituisci logo",
    "logo.saved": "Logo salvato",
    "logo.hint": "PNG/JPG/WEBP fino a 2 MB, stampato in alto a destra nell'intestazione dei modelli editor dell'entità selezionata.",
    "conn.docusign.name": "DocuSign eSignature",
    "conn.docusign.desc": "Invio dei PDF generati in firma elettronica ai clienti, per tutte le entità.",
    "fld.integration_key": "Integration Key",
    "fld.user_guid": "User ID (GUID)",
    "fld.account_id": "API Account ID",
    "fld.rsa_private_key": "Chiave privata RSA",
    "ds.step1": "In DocuSign Demo → Settings → Apps and Keys apri la tua app.",
    "ds.step2": "In “Redirect URIs” aggiungi l'indirizzo qui sotto e salva.",
    "ds.step3": "In “Service Integration” genera una RSA Keypair, copia la Private Key e incollala nel campo Chiave privata RSA (Configura).",
    "ds.step4": "Clicca “Dai il consenso” e accetta con l'utente DocuSign; poi “Testa connessione”.",
    "ds.copied": "Redirect URI copiato",
    "ds.ids": "Chiavi/ID",
    "ds.rsa": "Chiave RSA",
    "ds.missing": "mancante",
    "ds.consent": "Dai il consenso",
    "ds.test": "Testa connessione",
    "ds.testOk": "DocuSign connesso",
    "ds.consentOk": "Consenso DocuSign registrato: ora prova la connessione",
    "email.title": "Email",
    "email.subtitle": "Invia comunicazioni tramite la casella SMTP/PEC configurata. L'archivio è separato per l'entità selezionata in alto.",
    "email.new": "Nuova Email",
    "email.to": "Destinatario",
    "email.subject": "Oggetto",
    "email.body": "Corpo del messaggio",
    "email.template": "Template",
    "email.noTemplate": "— Nessun template —",
    "email.attachments": "Allegati dal Vault",
    "email.invoiceAttached": "XML fattura allegato automaticamente",
    "email.send": "Invia Email",
    "email.sentOk": "Email inviata e archiviata",
    "email.templates": "Template Email",
    "email.newTemplate": "Nuovo Template",
    "email.editTemplate": "Modifica Template",
    "email.templateName": "Nome template",
    "email.category": "Categoria",
    "email.cat.fattura": "Fatture",
    "email.cat.contratto": "Contratti",
    "email.cat.antiriciclaggio": "Antiriciclaggio",
    "email.cat.commercialista": "Commercialista",
    "email.cat.altro": "Altro",
    "email.archive": "Archivio Email",
    "email.noEmails": "Nessuna email inviata per questa entità",
    "email.status.sent": "Inviata",
    "email.status.failed": "Fallita",
    "email.smtpMissing": "Casella SMTP/PEC non configurata: vai su Connettori → Email SMTP/PEC",
    "email.placeholdersHint": "Segnaposto: {{nome_cliente}}, {{entita}}, {{data}}, {{numero_fattura}}, {{data_fattura}}",
    "conn.subtitle": "Collega servizi esterni: fatturazione elettronica, archiviazione cloud e messaggistica. Le credenziali sono salvate in modo sicuro e mai mostrate per intero.",
    "conn.connected": "Connesso",
    "conn.smtpTest": "Invia email di test",
    "conn.smtpTestOk": "Email di test inviata a",
    "nav.calendar": "Calendario",
    "cal.today": "Oggi",
    "cal.noDue": "Nessun task con scadenza in questo mese",
    "cal.more": "altri",
    "task.checklist": "Checklist",
    "task.addItem": "Aggiungi voce…",
    "task.attachments": "Allegati",
    "task.uploadFile": "Carica file",
    "task.fromVault": "Dal Vault",
    "task.noAttachments": "Nessun allegato",
    "task.pickVault": "Scegli un documento del Vault",
    "task.details": "Dettagli task",
    "task.recurrence": "Ricorrenza",
    "task.recNone": "Nessuna",
    "task.recWeekly": "Settimanale",
    "task.recMonthly": "Mensile",
    "task.recSpawned": "Task ricorrente: creata la prossima occorrenza",
    "task.everyone": "Tutti",
    "inv.createTask": "Crea task di sollecito in bacheca",
    "inv.taskCreated": "Task creato in bacheca",
    "inv.taskExists": "Esiste già un task aperto per questa fattura",
    "notif.taskDueSoon": "Scade domani",
    "tpl.title": "Modelli task",
    "tpl.saveAs": "Salva come modello",
    "tpl.name": "Nome modello",
    "tpl.dueDays": "Scadenza (giorni dalla creazione)",
    "tpl.saveHint": "Verranno salvati titolo, descrizione, priorità, ricorrenza, assegnatari e la checklist.",
    "tpl.saved": "Modello salvato",
    "tpl.applied": "Task creato dal modello",
    "tpl.use": "Usa",
    "tpl.days": "gg",
    "tpl.empty": "Nessun modello: apri un task e usa \"Salva come modello\"",
    "vault.createTask": "Crea task di rinnovo in bacheca",
    "dash.workload": "Carico di lavoro (7 giorni)",
    "dash.openBoard": "Apri bacheca",
    "dash.wlOpen": "aperti",
    "dash.wlDueWeek": "in scadenza",
    "dash.wlDoneWeek": "Completati ultimi 7 giorni",
    "dash.wlOverdue": "In ritardo",
    "dash.wlUnassigned": "task aperti senza assegnatario",
    "conn.notConnected": "Non configurato",
    "conn.configure": "Configura",
    "conn.disconnect": "Disconnetti",
    "conn.secretSet": "(già impostato - lascia vuoto per mantenere)",
    "conn.openapi_sdi.name": "Openapi SDI",
    "conn.openapi_sdi.desc": "Invio e ricezione fatture elettroniche tramite Sistema di Interscambio. Token da console.openapi.com.",
    "conn.aruba_fe.name": "Aruba Fatturazione Elettronica",
    "conn.aruba_fe.desc": "Canale SDI alternativo con account Aruba FE.",
    "conn.google_drive.name": "Google Drive",
    "conn.google_drive.desc": "Archiviazione automatica di fatture e documenti su una cartella Drive.",
    "conn.connect": "Connetti",
    "conn.sharedNote": "I connettori sono condivisi: visibili e utilizzabili da tutti gli utenti della piattaforma. Solo master e admin possono modificarli.",
    "conn.drive.connectedOk": "Google Drive collegato con successo. I nuovi documenti del vault verranno archiviati anche su Drive.",
    "conn.drive.error": "Collegamento a Google Drive non riuscito. Riprova.",
    "conn.drive.folder": "Cartella",
    "conn.drive.folderPlaceholder": "Link o ID della tua cartella Drive…",
    "conn.drive.folderSaved": "Cartella Drive impostata",
    "conn.whatsapp_business.name": "WhatsApp Business",
    "conn.whatsapp_business.desc": "Notifiche e solleciti pagamento via WhatsApp Cloud API.",
    "conn.smtp_email.name": "Email SMTP / PEC",
    "conn.twilio_whatsapp.name": "WhatsApp (Twilio)",
    "conn.twilio_whatsapp.desc": "Invia assegnazioni e promemoria task su WhatsApp tramite Twilio. Inserisci il numero mittente (sandbox o approvato) e il numero WhatsApp di ciascun utente in Utenti & Accessi.",
    "fld.from_number": "Numero mittente WhatsApp (es. +14155238886)",
    "conn.waTest": "Invia WhatsApp di test",
    "conn.waTestOk": "WhatsApp di test inviato a",
    "users.whatsapp": "Numero WhatsApp",
    "task.client": "Cliente",
    "task.noClient": "Nessun cliente",
    "task.amount": "Importo netto (€)",
    "task.billable": "Fatturabile",
    "task.billed": "Fatturato",
    "task.byClient": "Per cliente",
    "task.unbilled": "da fatturare",
    "task.createInvoice": "Crea bozza fattura",
    "task.invoiceCreated": "Bozza fattura creata: controllala in Fatture di Vendita",
    "task.history": "Storico",
    "task.noHistory": "Nessuna attività registrata",
    "act.created": "ha creato il task",
    "act.updated": "ha modificato",
    "act.moved": "ha spostato in",
    "act.completed": "ha completato il task",
    "act.commented": "ha commentato",
    "act.attached": "ha allegato",
    "act.checklist": "ha aggiornato la checklist",
    "act.billed": "ha fatturato",
    "act.timer_start": "ha avviato il timer",
    "act.timer_stop": "ha fermato il timer",
    "act.time_added": "ha registrato tempo",
    "task.time": "Ore",
    "task.hourlyRate": "Tariffa oraria (€/h)",
    "task.timerStart": "Avvia timer",
    "task.timerStop": "Ferma timer",
    "task.timerRunning": "Timer attivo",
    "task.addTime": "Aggiungi tempo manuale",
    "task.minutes": "Minuti",
    "task.note": "Nota",
    "task.totalHours": "Totale ore",
    "task.value": "Valore",
    "task.noTime": "Nessun tempo registrato",
    "task.report": "Report mensile",
    "task.reportSend": "Invia via email",
    "task.reportSent": "Report inviato agli amministratori",
    "task.reportHours": "Ore",
    "task.reportBilled": "Fatturato",
    "task.reportUnbilled": "Da fatturare",
    "task.reportDone": "Completati",
    "conn.smtp_email.desc": "Invio di fatture e resoconti via email o PEC.",
    "fld.api_token": "API Token",
    "fld.environment": "Ambiente (sandbox/production)",
    "fld.username": "Username",
    "fld.password": "Password",
    "fld.client_id": "Client ID",
    "fld.client_secret": "Client Secret",
    "fld.folder_id": "ID Cartella Drive",
    "fld.phone_number_id": "Phone Number ID",
    "fld.business_account_id": "Business Account ID",
    "fld.access_token": "Access Token",
    "fld.host": "Host SMTP",
    "fld.port": "Porta",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.add": "Aggiungi",
    "common.delete": "Elimina",
    "common.actions": "Azioni",
    "common.status": "Stato",
    "common.date": "Data",
    "common.dueDate": "Scadenza",
    "common.amount": "Importo",
    "common.net": "Imponibile",
    "common.vat": "IVA",
    "common.total": "Totale",
    "common.loading": "Caricamento...",
    "common.print": "Stampa",
    "common.export": "Esporta",
    "common.download": "Scarica",
    "common.upload": "Carica",
    "common.noData": "Nessun dato disponibile",
    "common.description": "Descrizione",
    "common.number": "Numero",
    "common.notes": "Note",
    "common.type": "Tipo",
    "common.name": "Nome",
    "common.all": "Tutte",
    "login.title": "Accedi a TrustMaster Advisor",
    "login.subtitle": "Una piattaforma unica per Partita IVA, SRL e LTD inglese: fatturazione, doppia partita, compliance e bilanci.",
    "login.google": "Accedi con Google",
    "entity.all": "Vista Consolidata",
    "dash.revenue": "Fatturato Totale",
    "dash.receivables": "Crediti da Incassare",
    "dash.payables": "Debiti da Pagare",
    "dash.upcoming": "Prossime Scadenze",
    "dash.cashflow": "Andamento Flussi di Cassa",
    "dash.inflow": "Entrate",
    "dash.outflow": "Uscite",
    "dash.net": "Netto",
    "dash.overdue": "Scaduta",
    "dash.expiringDocs": "Documenti in Scadenza (60 gg)",
    "dash.daysLeft": "gg rimasti",
    "inv.new": "Nuova Fattura",
    "inv.client": "Cliente",
    "inv.supplier": "Fornitore",
    "inv.vatRate": "Aliquota IVA %",
    "inv.markPaid": "Registra Pagamento",
    "inv.paymentAmount": "Importo pagato",
    "inv.unpaid": "Non pagata",
    "inv.paid": "Pagata",
    "inv.partial": "Parziale",
    "inv.sale": "Vendita",
    "inv.purchase": "Acquisto",
    "inv.drafts": "Bozze Fatture (da Contratti)",
    "inv.draft": "Bozza",
    "inv.edit": "Modifica",
    "inv.issue": "Emetti",
    "inv.issueTitle": "Emetti Fattura",
    "inv.lines": "Righe Fattura",
    "inv.qty": "Qtà",
    "inv.unitPrice": "Prezzo Unit.",
    "inv.addLine": "Aggiungi riga",
    "inv.paymentMethod": "Metodo di Pagamento",
    "inv.bonifico": "Bonifico Bancario",
    "inv.rid": "RID",
    "inv.riba": "RiBa",
    "inv.sendSdi": "Invia a SDI",
    "inv.sdiSent": "Fattura trasmessa allo SDI",
    "inv.sdiValidated": "XML validato da Aruba (dry-run, nessun invio reale)",
    "inv.sdiSync": "Aggiorna esito SDI",
    "inv.sendEmail": "Invia via Email",
    "inv.remind": "Invia sollecito di pagamento",
    "inv.remindOk": "Sollecito inviato a",
    "dash.sig.invoice_reminder": "Sollecito",
    "email.cat.sollecito": "Sollecito pagamento",
    "email.cat.sollecito_2": "Secondo sollecito",
    "email.cat.sollecito_3": "Terzo sollecito (mora)",
    "inv.creditNote": "Nota di credito",
    "inv.creditNoteFull": "Storno totale",
    "inv.creditNoteNet": "Imponibile da stornare",
    "inv.creditNoteOk": "Nota di credito emessa",
    "inv.selfInvoice": "Autofattura / integrazione",
    "inv.selfInvoiceOk": "Autofattura generata",
    "inv.selfType": "Tipo documento",
    "inv.td.TD16": "TD16 – Integrazione reverse charge interno",
    "inv.td.TD17": "TD17 – Acquisto servizi dall'estero",
    "inv.td.TD18": "TD18 – Acquisto beni intracomunitari",
    "inv.td.TD19": "TD19 – Acquisto beni ex art. 17 c.2",
    "inv.reminders": "Solleciti",
    "inv.thirdPending": "3° sollecito in attesa di invio manuale",
    "inv.prefs": "Impostazioni solleciti e riepilogo",
    "inv.prefThird": "Invia automaticamente anche il terzo sollecito (messa in mora)",
    "inv.prefDigest": "Ricevi ogni mattina il riepilogo giornaliero via email",
    "inv.digestPreview": "Anteprima riepilogo di oggi",
    "inv.digestEmpty": "Nessuna segnalazione per oggi",
    "ord.tab.expenses": "Note spese",
    "ord.tab.vat": "Registri IVA",
    "ord.tab.assets": "Cespiti",
    "ord.tab.bank": "Banca",
    "ord.tab.schedule": "Scadenzario",
    "ord.tab.f24": "F24",
    "ord.tab.yearend": "Chiusura e bilancio",
    "ord.ref.f24": "F24",
    "ord.ref.closing": "Chiusura",
    "ord.ref.reopening": "Riapertura",
    "wh.title": "Ritenuta d'acconto",
    "wh.short": "R.A.",
    "wh.rate": "Aliquota",
    "wh.base": "Base imponibile",
    "wh.hint": "Ritenuta calcolata:",
    "wh.saved": "Ritenuta registrata: il debito verso il fornitore è ridotto e la ritenuta va in F24",
    "wh.remove": "Rimuovi ritenuta",
    "sch.bank": "Saldo banca/cassa attuale",
    "sch.in": "Incassi previsti",
    "sch.out": "Pagamenti previsti",
    "sch.min": "Saldo minimo proiettato",
    "sch.horizon": "Orizzonte",
    "sch.projected": "Saldo proiettato",
    "f24.title": "Prospetto F24",
    "f24.month": "Mese di versamento",
    "f24.due": "Scadenza",
    "f24.hint": "Ritenute (1040) delle fatture pagate nel mese precedente e IVA delle liquidazioni in scadenza. La registrazione del versamento chiude i debiti Erario.",
    "f24.code": "Tributo",
    "f24.ref": "Periodo",
    "f24.pay": "Registra versamento F24",
    "f24.paidOn": "Versato il",
    "ye.profit": "Utile",
    "ye.loss": "Perdita",
    "ye.close": "Chiudi esercizio",
    "ye.reopen": "Riapertura",
    "ye.closed": "Esercizio chiuso",
    "ye.undo": "Annulla chiusura",
    "ye.hint": "La chiusura azzera costi e ricavi rilevando l'utile/perdita nel conto 2820; la riapertura destina il risultato a riserva (2810) al 1° gennaio. Il bilancio CEE è riclassificato dai conti del piano.",
    "ye.balanceSheet": "Stato patrimoniale",
    "ye.incomeStatement": "Conto economico",
    "ye.totalAssets": "Totale attivo",
    "ye.totalLiab": "Totale passivo",
    "ye.resultLine": "Risultato d'esercizio",
    "ye.diff": "Differenza",
    "ord.ref.depreciation": "Ammortamento",
    "fa.new": "Nuovo cespite",
    "fa.category": "Categoria",
    "fa.purchase": "Data acquisto",
    "fa.cost": "Costo storico",
    "fa.rate": "Aliquota",
    "fa.fund": "Fondo amm.",
    "fa.bookValue": "Valore netto",
    "fa.plan": "Piano",
    "fa.year": "Esercizio",
    "fa.quota": "Quota",
    "fa.yearQuota": "Quote dell'esercizio",
    "fa.depreciate": "Registra ammortamenti",
    "fa.undo": "Annulla ammortamenti",
    "fa.posted": "Contabilizzato",
    "fa.cat.macchine_ufficio": "Macchine d'ufficio",
    "fa.cat.mobili": "Mobili e arredi",
    "fa.cat.automezzi": "Automezzi",
    "fa.cat.impianti": "Impianti",
    "fa.cat.software": "Software",
    "fa.cat.marchi": "Marchi e brevetti",
    "fa.cat.altro": "Altro",
    "bank.import": "Importa estratto conto (CSV)",
    "bank.hint": "CSV con colonne Data, Descrizione e Importo (oppure Dare/Avere). I movimenti già presenti vengono saltati; le corrispondenze con fatture aperte e scritture sono suggerite con ★.",
    "bank.imported": "Movimenti importati",
    "bank.dup": "duplicati",
    "bank.unmatched": "Da abbinare",
    "bank.matched": "Abbinato",
    "bank.all": "Tutti",
    "bank.netFlow": "Saldo movimenti",
    "bank.matchWith": "Abbina a",
    "bank.choose": "Fattura, scrittura o causale…",
    "bank.invoice": "Fattura incassata/pagata",
    "bank.journal": "Scrittura",
    "exp.title": "Esporta",
    "exp.hint": "PDF o Excel per il commercialista",
    "exp.journal": "Libro giornale",
    "exp.trial-balance": "Bilancio di verifica",
    "exp.vat-sales": "Registro IVA vendite",
    "exp.vat-purchases": "Registro IVA acquisti",
    "exp.done": "Download avviato",
    "er.new": "Nuova nota spese",
    "er.employee": "Dipendente / Socio",
    "er.period": "Periodo",
    "er.items": "Voci di spesa",
    "er.receipt": "Ricevuta",
    "er.addItem": "Aggiungi voce",
    "er.approve": "Approva e contabilizza",
    "er.reimburse": "Registra rimborso",
    "er.status.draft": "Bozza",
    "er.status.approved": "Approvata",
    "er.status.reimbursed": "Rimborsata",
    "er.cat.viaggio": "Viaggio",
    "er.cat.vitto": "Vitto",
    "er.cat.alloggio": "Alloggio",
    "er.cat.carburante": "Carburante",
    "er.cat.materiali": "Materiali",
    "er.cat.altro": "Altro",
    "vat.period": "Periodo",
    "vat.sales": "Registro IVA vendite",
    "vat.purchases": "Registro IVA acquisti",
    "vat.debit": "IVA a debito",
    "vat.credit": "IVA a credito",
    "vat.balance": "Saldo periodo",
    "vat.toPay": "da versare",
    "vat.creditCarry": "a credito",
    "vat.liquidate": "Registra liquidazione IVA",
    "vat.liquidated": "Liquidazione registrata il",
    "vat.undo": "Annulla liquidazione",
    "vat.source": "Origine",
    "inv.xml": "Scarica XML FatturaPA",
    "set.fiscal": "Dati Fiscali Entità",
    "set.sellerName": "Denominazione / Nome",
    "set.sellerVat": "Partita IVA",
    "set.taxCode": "Codice Fiscale",
    "purch.aiTitle": "Estrazione AI da PDF",
    "purch.aiDesc": "Carica il PDF della fattura fornitore: l'AI estrae fornitore, data, importi e IVA automaticamente.",
    "purch.dropzone": "Trascina qui il PDF o clicca per selezionarlo",
    "purch.extracting": "Analisi AI in corso...",
    "purch.extracted": "Dati estratti - verifica e registra",
    "purch.register": "Registra Fattura",
    "purch.manual": "Inserimento Manuale",
    "contacts.title": "Anagrafiche Clienti & Fornitori",
    "contacts.client": "Cliente",
    "contacts.supplier": "Fornitore",
    "contacts.fullName": "Nome e Cognome",
    "contacts.ragione": "Ragione Sociale",
    "contacts.streetType": "Tipo",
    "contacts.street": "Indirizzo",
    "contacts.cap": "CAP",
    "contacts.city": "Città",
    "contacts.province": "Provincia",
    "contacts.visura": "Visura Camerale",
    "contacts.uploadVisura": "Carica Visura (PDF)",
    "contracts.new": "Nuovo Contratto",
    "contracts.title2": "Titolo",
    "contracts.counterparty": "Controparte",
    "contracts.value": "Valore",
    "contracts.start": "Inizio",
    "contracts.end": "Scadenza",
    "contracts.active": "Attivo",
    "contracts.expired": "Scaduto",
    "contracts.draft": "Bozza",
    "contracts.generate": "Genera Bozze Fatture",
    "contracts.invCount": "Numero fatture",
    "contracts.amountEach": "Importo per fattura",
    "contracts.firstDate": "Data prima fattura",
    "contracts.interval": "Intervallo (mesi)",
    "contracts.forms": "Documenti Contratto",
    "contracts.email": "Invia via Email",
    "contracts.contractDoc": "Contratto di Prestazione di Servizi",
    "contracts.parties": "Parti",
    "contracts.object": "Oggetto del Contratto",
    "contracts.provider": "Il Professionista / La Società",
    "contracts.theClient": "Il Cliente",
    "svc.new": "Nuova Prestazione",
    "svc.category": "Categoria",
    "svc.price": "Prezzo Unitario",
    "svc.currency": "Valuta",
    "svc.select": "Seleziona Prestazioni dal Listino",
    "svc.selectedTotal": "Totale Selezionato",
    "svc.empty": "Nessun articolo: aggiungilo dalla pagina Articoli",
    "cat.trust": "Articoli Trust",
    "cat.societa_estere": "Articoli Società Estere",
    "cat.consulenza": "Articoli Consulenza",
    "cat.consulenza_trust": "Articoli Consulenza Trust",
    "cat.consulenza_aziendale": "Articoli Consulenza Aziendale",
    "cat.marchi_brevetti": "Articoli Marchi e Brevetti",
    "cat.societa_innovative": "Articoli Società Innovative",
    "cat.consulenza_trustee": "Articoli Consulenza Trustee",
    "svc.seedTrust": "Carica Catalogo Trust (17 giurisdizioni)",
    "svc.seeded": "schede trust caricate nel listino",
    "svc.alreadySeeded": "Catalogo trust già caricato",
    "aml.formTitle": "Modulo di Adeguata Verifica — Antiriciclaggio (D.Lgs. 231/2007)",
    "privacy.formTitle": "Informativa Privacy — Art. 13 Reg. UE 2016/679 (GDPR)",
    "contacts.recipientCode": "Codice Destinatario SDI",
    "aml.title": "Antiriciclaggio (AML/KYC)",
    "aml.new": "Nuova Verifica",
    "aml.subject": "Soggetto",
    "aml.risk": "Livello di Rischio",
    "aml.low": "Basso",
    "aml.medium": "Medio",
    "aml.high": "Alto",
    "aml.owner": "Titolare Effettivo",
    "aml.checkDate": "Data Verifica",
    "aml.pending": "In attesa",
    "aml.verified": "Verificato",
    "aml.expiredV": "Scaduta",
    "privacy.title": "Registro Trattamenti Privacy (GDPR)",
    "privacy.new": "Nuovo Trattamento",
    "privacy.treatment": "Trattamento",
    "privacy.purpose": "Finalità",
    "privacy.legalBasis": "Base Giuridica",
    "privacy.categories": "Categorie di Dati",
    "privacy.retention": "Conservazione",
    "vault.title": "Raccolta Documenti d'Identità",
    "vault.upload": "Carica Documento",
    "vault.subject": "Intestatario",
    "vault.docType": "Tipo Documento",
    "vault.identity": "Carta d'Identità",
    "vault.passport": "Passaporto",
    "vault.taxcode": "Codice Fiscale",
    "vault.other": "Altro",
    "vault.search": "Cerca documenti…",
    "vault.expiry": "Scadenza",
    "vault.edit": "Modifica documento",
    "vault.visura": "Visura camerale",
    "vault.durc": "DURC",
    "vault.contract": "Contratto",
    "ledger.accounts": "Piano dei Conti",
    "ledger.journal": "Prima Nota (Doppia Partita)",
    "ledger.new": "Nuova Registrazione",
    "ledger.code": "Codice",
    "ledger.debit": "Dare",
    "ledger.credit": "Avere",
    "ledger.account": "Conto",
    "ord.badge": "Contabilità ordinaria",
    "ord.subtitle": "Partita doppia con causali personalizzabili, partite aperte clienti/fornitori, mastrini e bilancio di verifica.",
    "ord.tab.journal": "Prima Nota",
    "ord.tab.open": "Partite aperte",
    "ord.tab.causali": "Causali",
    "ord.tab.accounts": "Piano dei conti",
    "ord.tab.trial": "Bilancio di verifica",
    "ord.newEntry": "Nuova registrazione",
    "ord.causale": "Causale",
    "ord.pickCausale": "Scegli la causale…",
    "ord.amountTotal": "Importo totale (IVA inclusa)",
    "ord.amountNet": "Imponibile",
    "ord.vatRate": "Aliquota IVA",
    "ord.docRef": "Riferimento documento",
    "ord.contact": "Cliente / Fornitore",
    "ord.net": "Imponibile",
    "ord.vat": "IVA",
    "ord.total": "Totale",
    "ord.addLine": "Aggiungi riga",
    "ord.unbalanced": "Scrittura non quadrata",
    "ord.balanced": "Quadrato",
    "ord.searchJournal": "Cerca in prima nota…",
    "ord.ref.invoice": "Fattura",
    "ord.ref.payment": "Pagamento",
    "ord.ref.settlement": "Incasso/Pag.",
    "ord.ref.manual": "Manuale",
    "ord.ref.causale": "Causale",
    "ord.ref.credit_note": "Nota credito",
    "ord.ref.self_invoice": "Autofattura",
    "ord.ref.expense_report": "Nota spese",
    "ord.ref.vat_liquidation": "Liq. IVA",
    "common.edit": "Modifica",
    "ord.causaliHint": "Le causali precompilano la scrittura in partita doppia: puoi modificarle o crearne di nuove.",
    "ord.newCausale": "Nuova causale",
    "ord.editCausale": "Modifica causale",
    "ord.groupLbl": "Gruppo",
    "ord.baseLbl": "Importo inserito",
    "ord.register": "Registro IVA",
    "ord.noVat": "Senza IVA",
    "ord.causaleLines": "Righe della scrittura",
    "ord.group.vendite": "Vendite",
    "ord.group.acquisti": "Acquisti",
    "ord.group.finanza": "Cassa e banca",
    "ord.group.spese": "Note spese",
    "ord.group.personale": "Personale",
    "ord.group.iva": "IVA",
    "ord.group.altro": "Altro",
    "ord.amt.total": "Totale",
    "ord.amt.net": "Imponibile",
    "ord.amt.vat": "IVA",
    "ord.amt.manual": "Manuale",
    "ord.receivables": "Crediti v/clienti",
    "ord.payables": "Debiti v/fornitori",
    "ord.residual": "Residuo",
    "ord.settle": "Registra incasso/pagamento",
    "ord.confirmSettle": "Conferma registrazione",
    "ord.settledOk": "Partite chiuse e scrittura registrata",
    "ord.mixedKinds": "Seleziona solo crediti o solo debiti per una registrazione.",
    "ord.finAccount": "Conto finanziario",
    "ord.autoDesc": "Automatica se vuota",
    "ord.searchAccount": "Cerca conto…",
    "ord.newAccount": "Nuovo conto",
    "ord.editAccount": "Modifica conto",
    "ord.mastrino": "Mastrino",
    "ord.balance": "Saldo",
    "ord.balanceDebit": "Saldo Dare",
    "ord.balanceCredit": "Saldo Avere",
    "ord.trialHint": "Somma di tutti i movimenti Dare e Avere per conto: i totali devono coincidere.",
    "ord.type.asset": "Attivo",
    "ord.type.liability": "Passivo",
    "ord.type.equity": "Patrimonio netto",
    "ord.type.revenue": "Ricavo",
    "ord.type.expense": "Costo",
    "inv.number": "Numero",
    "rep.ce": "Conto Economico",
    "rep.sp": "Stato Patrimoniale",
    "rep.vat": "Registri IVA",
    "rep.uk": "UK Balance Sheet",
    "rep.export": "Export Commercialista",
    "rep.revenues": "Ricavi",
    "rep.expenses": "Costi",
    "rep.result": "Risultato d'Esercizio",
    "rep.assets": "Attività",
    "rep.liabilities": "Passività",
    "rep.equity": "Patrimonio Netto",
    "rep.salesReg": "Registro IVA Vendite",
    "rep.purchReg": "Registro IVA Acquisti",
    "rep.from": "Dal",
    "rep.to": "Al",
    "rep.protocol": "Prot.",
    "rep.exportDesc": "Scarica il file CSV con tutte le registrazioni in doppia partita da consegnare al commercialista.",
    "uk.title": "Balance Sheet (FRS 102 format)",
    "uk.turnover": "Turnover",
    "uk.admin": "Administrative expenses",
    "uk.fixedAssets": "Fixed assets",
    "uk.currentAssets": "Current assets",
    "uk.creditors": "Creditors: amounts falling due within one year",
    "uk.netAssets": "Net assets",
    "uk.capital": "Capital and reserves",
    "uk.profit": "Profit for the financial year",
    "cf.forecast": "Previsione Incassi & Pagamenti",
    "cf.actual": "Movimenti Effettivi",
    "cf.month": "Mese",
    "msg.saved": "Salvato con successo",
    "msg.deleted": "Eliminato",
    "msg.error": "Errore durante l'operazione",
    "msg.extractFail": "Estrazione AI non riuscita, inserisci i dati manualmente",
  },
  en: {
    "app.name": "TrustMaster Advisor",
    "app.tagline": "Multi-entity accounting suite",
    "nav.overview": "Overview",
    "nav.dashboard": "Financial Dashboard",
    "nav.cashflow": "Cash Flow",
    "nav.task": "Tasks",
    "nav.boards": "Boards",
    "boards.new": "New Board",
    "boards.name": "Board Name",
    "boards.open": "Open",
    "boards.tasks": "tasks",
    "boards.setBg": "Set background image",
    "login.tabEmail": "Email + SMS OTP",
    "login.email": "Email",
    "login.password": "Password",
    "login.otp": "OTP code received via SMS",
    "login.continue": "Continue",
    "login.login": "Sign in",
    "login.verify": "Verify & Sign in",
    "login.firstAccess": "First access: we sent you an SMS code. Create your password.",
    "login.newPassword": "New Password (min. 8 characters)",
    "login.setupBtn": "Create Password & Sign in",
    "login.forgot": "Forgot password?",
    "login.resetHelp": "Password reset: enter the code you received and choose a new password.",
    "login.resetBtn": "Reset Password & Sign in",
    "login.otpSent": "SMS code sent",
    "login.resend": "Resend SMS code",
    "login.sentSms": "Code sent via SMS",
    "login.sentEmail": "Code sent via Email",
    "login.manualCode": "Enter the access code provided by your administrator",
    "nav.users": "Users & Access",
    "users.add": "New User",
    "users.role": "Role",
    "users.phone": "OTP Phone (SMS)",
    "users.master": "Master",
    "users.admin": "Administrator",
    "users.member": "Member",
    "users.viewer": "Boards only",
    "task.assignees": "Assigned to",
    "task.noUsers": "No users: create them in Users & Access",
    "task.onlyMine": "Only my tasks",
    "task.assignedToYou": "Tasks assigned to you",
    "users.pwdSet": "Password active",
    "users.pwdPending": "Pending first access",
    "users.hint": "The new user will create their password at first access, after verifying the SMS code sent to their phone.",
    "users.resetPwd": "Reset user password",
    "users.resetDone": "Password reset: the user will set a new password at next login (OTP verification).",
    "users.accessCode": "Generate manual access code",
    "users.accessCodeTitle": "Manual access code (valid 10 minutes)",
    "users.accessCodeHelp": "Share this code with the user by phone/WhatsApp. On the login page, after email (and password if already set), they enter it as the OTP code. It works as an email-channel code.",
    "users.forbidden": "Restricted to Master and Administrators",
    "task.new": "New Task",
    "task.edit": "Edit Task",
    "task.title": "Title",
    "task.assignee": "Assigned to",
    "task.priority": "Priority",
    "task.entity": "Entity",
    "task.members": "Team Members",
    "task.role": "Permissions",
    "task.roleWrite": "Write",
    "task.roleRead": "Read Only",
    "task.low": "Low",
    "task.medium": "Medium",
    "task.high": "High",
    "task.col.todo": "To Do",
    "task.col.doing": "In Progress",
    "task.col.review": "In Review",
    "task.col.done": "Done",
    "nav.accounting": "Accounting Operations",
    "nav.sales": "Sales Invoices",
    "nav.purchases": "Purchase Invoices",
    "nav.ledger": "Chart of Accounts & Ledger",
    "nav.reportsGroup": "Reports & Registers",
    "nav.reports": "P&L & Balance Sheet",
    "nav.contacts": "Contacts",
    "nav.services": "Articles",
    "nav.legal": "Compliance & Legal",
    "nav.contracts": "Contracts",
    "nav.compliance": "AML & Privacy",
    "nav.vault": "Identity Vault",
    "nav.integrations": "Integrations",
    "nav.connectors": "Connectors",
    "nav.emails": "Email",
    "nav.forms": "Doc Templates",
    "forms.title": "Doc Templates",
    "forms.subtitle": "Upload your Word templates (letterhead included), fill them with registry data, generate the PDF and send it via email or DocuSign signature.",
    "forms.upload": "Upload Word Template",
    "forms.name": "Template name",
    "forms.category": "Category",
    "forms.cat.contratto": "Contracts",
    "forms.cat.antiriciclaggio": "AML",
    "forms.cat.privacy": "Privacy",
    "forms.file": ".docx file",
    "forms.templates": "Uploaded templates",
    "forms.noTemplates": "No templates uploaded yet: upload your first .docx",
    "forms.generate": "Generate",
    "forms.generateTitle": "Generate document from template",
    "forms.contact": "Client (registry)",
    "forms.noContact": "— None / fill manually —",
    "forms.loadFields": "Load fields",
    "forms.fields": "Template fields (pre-filled from registry, editable)",
    "forms.generatePdf": "Generate PDF",
    "forms.generatedOk": "PDF document generated and archived",
    "forms.archive": "Generated Documents",
    "forms.noDocs": "No documents generated for this entity",
    "forms.download": "Download PDF",
    "forms.email": "Send Email",
    "forms.docusign": "Send for signature",
    "forms.signerName": "Signer name",
    "forms.signerEmail": "Signer email",
    "forms.docusignSent": "DocuSign envelope sent to signer",
    "forms.status.generated": "Generated",
    "forms.status.emailed": "Emailed",
    "forms.status.docusign_sent": "Signing (DocuSign)",
    "forms.sync": "Refresh signature status",
    "forms.uploadOk": "Template uploaded",
    "forms.placeholdersFound": "Placeholders detected in template",
    "forms.tabAll": "All",
    "forms.docsTab": "Templates & documents",
    "forms.records": "Register",
    "forms.or": "or",
    "forms.newHtml": "New template with editor",
    "forms.editHtml": "Edit template",
    "forms.kind.html": "Editor",
    "forms.insertPlaceholder": "Insert placeholder…",
    "forms.letterhead": "Automatic letterhead (entity name and fiscal data)",
    "forms.saveTemplate": "Save template",
    "forms.addDefaults": "Add default templates (contract, AML, privacy)",
    "forms.defaultsAdded": "Default templates added",
    "forms.defaultsExist": "Default templates already present",
    "forms.preview": "PDF preview",
    "forms.emailPreview": "Email preview to client",
    "forms.emailBodyHint": "Leave empty to use the standard text. You can use {{entita}}, {{data}}.",
    "forms.dualSign": "Entity signs too (second signer, after the client)",
    "forms.secondSignerName": "Entity signer name",
    "forms.secondSignerEmail": "Entity signer email",
    "forms.dualSignHint": "The client signs first; then DocuSign routes the envelope to the entity signer.",
    "dash.signatures": "DocuSign signatures",
    "dash.noSignatures": "No new signatures: envelope status is refreshed hourly.",
    "dash.sig.docusign_completed": "Signed",
    "dash.sig.docusign_declined": "Declined",
    "dash.sig.docusign_voided": "Voided",
    "dash.markRead": "Mark as read",
    "dash.sig.docusign_reminder": "Reminder",
    "notif.title": "Notifications",
    "notif.empty": "No notifications for this entity",
    "notif.docExpired": "Document expired",
    "notif.taskOverdue": "Task overdue since",
    "notif.taskDue": "Task due on",
    "task.comments": "Comments",
    "task.addComment": "Write a comment…",
    "task.send": "Send",
    "task.noComments": "No comments yet",
    "task.dragHint": "Drag cards between columns",
    "notif.docExpiring": "Expires in",
    "notif.invoiceOverdue": "Invoice overdue since",
    "forms.remind": "Send signature reminder",
    "forms.remindOk": "Reminder sent to signer",
    "forms.signedCopy": "Signed copy archived in Vault",
    "logo.title": "Letterhead logo",
    "logo.none": "No logo",
    "logo.upload": "Upload logo",
    "logo.replace": "Replace logo",
    "logo.saved": "Logo saved",
    "logo.hint": "PNG/JPG/WEBP up to 2 MB, printed top-right in the letterhead of editor templates for the selected entity.",
    "conn.docusign.name": "DocuSign eSignature",
    "conn.docusign.desc": "Send generated PDFs to clients for electronic signature, for all entities.",
    "fld.integration_key": "Integration Key",
    "fld.user_guid": "User ID (GUID)",
    "fld.account_id": "API Account ID",
    "fld.rsa_private_key": "RSA private key",
    "ds.step1": "In DocuSign Demo → Settings → Apps and Keys open your app.",
    "ds.step2": "Under “Redirect URIs” add the address below and save.",
    "ds.step3": "Under “Service Integration” generate an RSA Keypair, copy the Private Key and paste it into the RSA private key field (Configure).",
    "ds.step4": "Click “Grant consent” and accept with your DocuSign user; then “Test connection”.",
    "ds.copied": "Redirect URI copied",
    "ds.ids": "Keys/IDs",
    "ds.rsa": "RSA key",
    "ds.missing": "missing",
    "ds.consent": "Grant consent",
    "ds.test": "Test connection",
    "ds.testOk": "DocuSign connected",
    "ds.consentOk": "DocuSign consent recorded: now test the connection",
    "email.title": "Email",
    "email.subtitle": "Send communications via the configured SMTP/PEC mailbox. The archive is separated by the entity selected at the top.",
    "email.new": "New Email",
    "email.to": "Recipient",
    "email.subject": "Subject",
    "email.body": "Message body",
    "email.template": "Template",
    "email.noTemplate": "— No template —",
    "email.attachments": "Attachments from Vault",
    "email.invoiceAttached": "Invoice XML attached automatically",
    "email.send": "Send Email",
    "email.sentOk": "Email sent and archived",
    "email.templates": "Email Templates",
    "email.newTemplate": "New Template",
    "email.editTemplate": "Edit Template",
    "email.templateName": "Template name",
    "email.category": "Category",
    "email.cat.fattura": "Invoices",
    "email.cat.contratto": "Contracts",
    "email.cat.antiriciclaggio": "AML",
    "email.cat.commercialista": "Accountant",
    "email.cat.altro": "Other",
    "email.archive": "Email Archive",
    "email.noEmails": "No emails sent for this entity",
    "email.status.sent": "Sent",
    "email.status.failed": "Failed",
    "email.smtpMissing": "SMTP/PEC mailbox not configured: go to Connectors → Email SMTP/PEC",
    "email.placeholdersHint": "Placeholders: {{nome_cliente}}, {{entita}}, {{data}}, {{numero_fattura}}, {{data_fattura}}",
    "conn.subtitle": "Connect external services: e-invoicing, cloud storage and messaging. Credentials are stored securely and never shown in full.",
    "conn.connected": "Connected",
    "conn.smtpTest": "Send test email",
    "conn.smtpTestOk": "Test email sent to",
    "nav.calendar": "Calendar",
    "cal.today": "Today",
    "cal.noDue": "No tasks due this month",
    "cal.more": "more",
    "task.checklist": "Checklist",
    "task.addItem": "Add item…",
    "task.attachments": "Attachments",
    "task.uploadFile": "Upload file",
    "task.fromVault": "From Vault",
    "task.noAttachments": "No attachments",
    "task.pickVault": "Pick a Vault document",
    "task.details": "Task details",
    "task.recurrence": "Recurrence",
    "task.recNone": "None",
    "task.recWeekly": "Weekly",
    "task.recMonthly": "Monthly",
    "task.recSpawned": "Recurring task: next occurrence created",
    "task.everyone": "Everyone",
    "inv.createTask": "Create follow-up task on board",
    "inv.taskCreated": "Task created on board",
    "inv.taskExists": "An open task already exists for this invoice",
    "notif.taskDueSoon": "Due tomorrow",
    "tpl.title": "Task templates",
    "tpl.saveAs": "Save as template",
    "tpl.name": "Template name",
    "tpl.dueDays": "Due (days after creation)",
    "tpl.saveHint": "Title, description, priority, recurrence, assignees and checklist will be saved.",
    "tpl.saved": "Template saved",
    "tpl.applied": "Task created from template",
    "tpl.use": "Use",
    "tpl.days": "d",
    "tpl.empty": "No templates yet: open a task and use \"Save as template\"",
    "vault.createTask": "Create renewal task on board",
    "dash.workload": "Workload (7 days)",
    "dash.openBoard": "Open board",
    "dash.wlOpen": "open",
    "dash.wlDueWeek": "due soon",
    "dash.wlDoneWeek": "Done in last 7 days",
    "dash.wlOverdue": "Overdue",
    "dash.wlUnassigned": "open tasks without assignee",
    "conn.notConnected": "Not configured",
    "conn.configure": "Configure",
    "conn.disconnect": "Disconnect",
    "conn.secretSet": "(already set - leave empty to keep)",
    "conn.openapi_sdi.name": "Openapi SDI",
    "conn.openapi_sdi.desc": "Send and receive Italian e-invoices via SDI. Token from console.openapi.com.",
    "conn.aruba_fe.name": "Aruba E-Invoicing",
    "conn.aruba_fe.desc": "Alternative SDI channel with an Aruba FE account.",
    "conn.google_drive.name": "Google Drive",
    "conn.google_drive.desc": "Automatic archiving of invoices and documents to a Drive folder.",
    "conn.connect": "Connect",
    "conn.sharedNote": "Connectors are shared: visible and usable by all platform users. Only master and admin users can modify them.",
    "conn.drive.connectedOk": "Google Drive connected successfully. New vault documents will also be archived to Drive.",
    "conn.drive.error": "Google Drive connection failed. Please try again.",
    "conn.drive.folder": "Folder",
    "conn.drive.folderPlaceholder": "Link or ID of your Drive folder…",
    "conn.drive.folderSaved": "Drive folder set",
    "conn.whatsapp_business.name": "WhatsApp Business",
    "conn.whatsapp_business.desc": "Notifications and payment reminders via WhatsApp Cloud API.",
    "conn.smtp_email.name": "SMTP Email / PEC",
    "conn.twilio_whatsapp.name": "WhatsApp (Twilio)",
    "conn.twilio_whatsapp.desc": "Send task assignments and reminders via WhatsApp through Twilio. Enter the sender number (sandbox or approved) and each user's WhatsApp number in Users & Access.",
    "fld.from_number": "WhatsApp sender number (e.g. +14155238886)",
    "conn.waTest": "Send test WhatsApp",
    "conn.waTestOk": "Test WhatsApp sent to",
    "users.whatsapp": "WhatsApp number",
    "task.client": "Client",
    "task.noClient": "No client",
    "task.amount": "Net amount (€)",
    "task.billable": "Billable",
    "task.billed": "Billed",
    "task.byClient": "By client",
    "task.unbilled": "to bill",
    "task.createInvoice": "Create draft invoice",
    "task.invoiceCreated": "Draft invoice created: check it in Sales Invoices",
    "task.history": "History",
    "task.noHistory": "No activity recorded",
    "act.created": "created the task",
    "act.updated": "updated",
    "act.moved": "moved to",
    "act.completed": "completed the task",
    "act.commented": "commented",
    "act.attached": "attached",
    "act.checklist": "updated the checklist",
    "act.billed": "billed",
    "act.timer_start": "started the timer",
    "act.timer_stop": "stopped the timer",
    "act.time_added": "logged time",
    "task.time": "Hours",
    "task.hourlyRate": "Hourly rate (€/h)",
    "task.timerStart": "Start timer",
    "task.timerStop": "Stop timer",
    "task.timerRunning": "Timer running",
    "task.addTime": "Add manual time",
    "task.minutes": "Minutes",
    "task.note": "Note",
    "task.totalHours": "Total hours",
    "task.value": "Value",
    "task.noTime": "No time logged",
    "task.report": "Monthly report",
    "task.reportSend": "Send by email",
    "task.reportSent": "Report sent to administrators",
    "task.reportHours": "Hours",
    "task.reportBilled": "Billed",
    "task.reportUnbilled": "To bill",
    "task.reportDone": "Done",
    "conn.smtp_email.desc": "Send invoices and reports via email or PEC.",
    "fld.api_token": "API Token",
    "fld.environment": "Environment (sandbox/production)",
    "fld.username": "Username",
    "fld.password": "Password",
    "fld.client_id": "Client ID",
    "fld.client_secret": "Client Secret",
    "fld.folder_id": "Drive Folder ID",
    "fld.phone_number_id": "Phone Number ID",
    "fld.business_account_id": "Business Account ID",
    "fld.access_token": "Access Token",
    "fld.host": "SMTP Host",
    "fld.port": "Port",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.add": "Add",
    "common.delete": "Delete",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.date": "Date",
    "common.dueDate": "Due date",
    "common.amount": "Amount",
    "common.net": "Net",
    "common.vat": "VAT",
    "common.total": "Total",
    "common.loading": "Loading...",
    "common.print": "Print",
    "common.export": "Export",
    "common.download": "Download",
    "common.upload": "Upload",
    "common.noData": "No data available",
    "common.description": "Description",
    "common.number": "Number",
    "common.notes": "Notes",
    "common.type": "Type",
    "common.name": "Name",
    "common.all": "All",
    "login.title": "Sign in to TrustMaster Advisor",
    "login.subtitle": "One platform for your Sole Trader, Italian SRL and UK LTD: invoicing, double-entry, compliance and financial statements.",
    "login.google": "Sign in with Google",
    "entity.all": "Consolidated View",
    "dash.revenue": "Total Revenue",
    "dash.receivables": "Receivables",
    "dash.payables": "Payables",
    "dash.upcoming": "Upcoming Deadlines",
    "dash.cashflow": "Cash Flow Trend",
    "dash.inflow": "Inflow",
    "dash.outflow": "Outflow",
    "dash.net": "Net",
    "dash.overdue": "Overdue",
    "dash.expiringDocs": "Expiring Documents (60 days)",
    "dash.daysLeft": "days left",
    "inv.new": "New Invoice",
    "inv.client": "Client",
    "inv.supplier": "Supplier",
    "inv.vatRate": "VAT rate %",
    "inv.markPaid": "Record Payment",
    "inv.paymentAmount": "Amount paid",
    "inv.unpaid": "Unpaid",
    "inv.paid": "Paid",
    "inv.partial": "Partial",
    "inv.sale": "Sale",
    "inv.purchase": "Purchase",
    "inv.drafts": "Invoice Drafts (from Contracts)",
    "inv.draft": "Draft",
    "inv.edit": "Edit",
    "inv.issue": "Issue",
    "inv.issueTitle": "Issue Invoice",
    "inv.lines": "Invoice Lines",
    "inv.qty": "Qty",
    "inv.unitPrice": "Unit Price",
    "inv.addLine": "Add line",
    "inv.paymentMethod": "Payment Method",
    "inv.bonifico": "Bank Transfer",
    "inv.rid": "RID",
    "inv.riba": "RiBa",
    "inv.sendSdi": "Send to SDI",
    "inv.sdiSent": "Invoice transmitted to SDI",
    "inv.sdiValidated": "XML validated by Aruba (dry-run, not actually sent)",
    "inv.sdiSync": "Sync SDI status",
    "inv.sendEmail": "Send via Email",
    "inv.remind": "Send payment reminder",
    "inv.remindOk": "Reminder sent to",
    "dash.sig.invoice_reminder": "Reminder",
    "email.cat.sollecito": "Payment reminder",
    "email.cat.sollecito_2": "Second reminder",
    "email.cat.sollecito_3": "Third reminder (default notice)",
    "inv.creditNote": "Credit note",
    "inv.creditNoteFull": "Full reversal",
    "inv.creditNoteNet": "Net amount to reverse",
    "inv.creditNoteOk": "Credit note issued",
    "inv.selfInvoice": "Self-invoice / VAT integration",
    "inv.selfInvoiceOk": "Self-invoice generated",
    "inv.selfType": "Document type",
    "inv.td.TD16": "TD16 – Domestic reverse charge",
    "inv.td.TD17": "TD17 – Services purchased abroad",
    "inv.td.TD18": "TD18 – Intra-EU goods",
    "inv.td.TD19": "TD19 – Goods art. 17 c.2",
    "inv.reminders": "Reminders",
    "inv.thirdPending": "3rd reminder awaiting manual send",
    "inv.prefs": "Reminder & digest settings",
    "inv.prefThird": "Automatically send the third reminder too (default notice)",
    "inv.prefDigest": "Receive the daily digest by email every morning",
    "inv.digestPreview": "Preview today's digest",
    "inv.digestEmpty": "Nothing to report today",
    "ord.tab.expenses": "Expense reports",
    "ord.tab.vat": "VAT registers",
    "ord.tab.assets": "Fixed assets",
    "ord.tab.bank": "Bank",
    "ord.tab.schedule": "Cash schedule",
    "ord.tab.f24": "F24",
    "ord.tab.yearend": "Year-end & statements",
    "ord.ref.f24": "F24",
    "ord.ref.closing": "Closing",
    "ord.ref.reopening": "Reopening",
    "wh.title": "Withholding tax",
    "wh.short": "W/H",
    "wh.rate": "Rate",
    "wh.base": "Taxable base",
    "wh.hint": "Computed withholding:",
    "wh.saved": "Withholding saved: supplier payable reduced, tax goes to F24",
    "wh.remove": "Remove withholding",
    "sch.bank": "Current bank/cash balance",
    "sch.in": "Expected receipts",
    "sch.out": "Expected payments",
    "sch.min": "Minimum projected balance",
    "sch.horizon": "Horizon",
    "sch.projected": "Projected balance",
    "f24.title": "F24 statement",
    "f24.month": "Payment month",
    "f24.due": "Due",
    "f24.hint": "Withholdings (1040) on invoices paid the previous month and VAT from settlements falling due. Recording the payment clears tax payables.",
    "f24.code": "Tax code",
    "f24.ref": "Period",
    "f24.pay": "Record F24 payment",
    "f24.paidOn": "Paid on",
    "ye.profit": "Profit",
    "ye.loss": "Loss",
    "ye.close": "Close year",
    "ye.reopen": "Reopen",
    "ye.closed": "Year closed",
    "ye.undo": "Undo closing",
    "ye.hint": "Closing zeroes revenues and expenses posting the result to 2820; reopening allocates it to reserves (2810) on Jan 1st. The statements are reclassified from the chart of accounts.",
    "ye.balanceSheet": "Balance sheet",
    "ye.incomeStatement": "Income statement",
    "ye.totalAssets": "Total assets",
    "ye.totalLiab": "Total liabilities & equity",
    "ye.resultLine": "Result for the year",
    "ye.diff": "Difference",
    "ord.ref.depreciation": "Depreciation",
    "fa.new": "New asset",
    "fa.category": "Category",
    "fa.purchase": "Purchase date",
    "fa.cost": "Cost",
    "fa.rate": "Rate",
    "fa.fund": "Acc. depreciation",
    "fa.bookValue": "Book value",
    "fa.plan": "Plan",
    "fa.year": "Year",
    "fa.quota": "Charge",
    "fa.yearQuota": "Charges for the year",
    "fa.depreciate": "Post depreciation",
    "fa.undo": "Undo depreciation",
    "fa.posted": "Posted",
    "fa.cat.macchine_ufficio": "Office equipment",
    "fa.cat.mobili": "Furniture",
    "fa.cat.automezzi": "Vehicles",
    "fa.cat.impianti": "Plant & machinery",
    "fa.cat.software": "Software",
    "fa.cat.marchi": "Trademarks & patents",
    "fa.cat.altro": "Other",
    "bank.import": "Import bank statement (CSV)",
    "bank.hint": "CSV with Date, Description and Amount columns (or Debit/Credit). Existing movements are skipped; matches with open invoices and entries are suggested with ★.",
    "bank.imported": "Movements imported",
    "bank.dup": "duplicates",
    "bank.unmatched": "To match",
    "bank.matched": "Matched",
    "bank.all": "All",
    "bank.netFlow": "Net flow",
    "bank.matchWith": "Match with",
    "bank.choose": "Invoice, entry or template…",
    "bank.invoice": "Invoice settled",
    "bank.journal": "Journal entry",
    "exp.title": "Export",
    "exp.hint": "PDF or Excel for the accountant",
    "exp.journal": "General journal",
    "exp.trial-balance": "Trial balance",
    "exp.vat-sales": "Sales VAT register",
    "exp.vat-purchases": "Purchases VAT register",
    "exp.done": "Download started",
    "er.new": "New expense report",
    "er.employee": "Employee / Partner",
    "er.period": "Period",
    "er.items": "Expense items",
    "er.receipt": "Receipt",
    "er.addItem": "Add item",
    "er.approve": "Approve & post",
    "er.reimburse": "Record reimbursement",
    "er.status.draft": "Draft",
    "er.status.approved": "Approved",
    "er.status.reimbursed": "Reimbursed",
    "er.cat.viaggio": "Travel",
    "er.cat.vitto": "Meals",
    "er.cat.alloggio": "Lodging",
    "er.cat.carburante": "Fuel",
    "er.cat.materiali": "Materials",
    "er.cat.altro": "Other",
    "vat.period": "Period",
    "vat.sales": "Sales VAT register",
    "vat.purchases": "Purchases VAT register",
    "vat.debit": "Output VAT",
    "vat.credit": "Input VAT",
    "vat.balance": "Period balance",
    "vat.toPay": "payable",
    "vat.creditCarry": "credit",
    "vat.liquidate": "Post VAT settlement",
    "vat.liquidated": "Settlement posted on",
    "vat.undo": "Undo settlement",
    "vat.source": "Source",
    "inv.xml": "Download FatturaPA XML",
    "set.fiscal": "Entity Fiscal Data",
    "set.sellerName": "Legal Name",
    "set.sellerVat": "VAT Number",
    "set.taxCode": "Tax Code",
    "purch.aiTitle": "AI PDF Extraction",
    "purch.aiDesc": "Upload the supplier invoice PDF: AI extracts vendor, date, amounts and VAT automatically.",
    "purch.dropzone": "Drop the PDF here or click to select",
    "purch.extracting": "AI analysis in progress...",
    "purch.extracted": "Extracted data - review and register",
    "purch.register": "Register Invoice",
    "purch.manual": "Manual Entry",
    "contacts.title": "Clients & Suppliers Directory",
    "contacts.client": "Client",
    "contacts.supplier": "Supplier",
    "contacts.fullName": "First & Last Name",
    "contacts.ragione": "Company Name",
    "contacts.streetType": "Type",
    "contacts.street": "Street Address",
    "contacts.cap": "ZIP Code",
    "contacts.city": "City",
    "contacts.province": "Province",
    "contacts.visura": "Chamber of Commerce Extract",
    "contacts.uploadVisura": "Upload Extract (PDF)",
    "contracts.new": "New Contract",
    "contracts.title2": "Title",
    "contracts.counterparty": "Counterparty",
    "contracts.value": "Value",
    "contracts.start": "Start",
    "contracts.end": "Expiry",
    "contracts.active": "Active",
    "contracts.expired": "Expired",
    "contracts.draft": "Draft",
    "contracts.generate": "Generate Invoice Drafts",
    "contracts.invCount": "Number of invoices",
    "contracts.amountEach": "Amount per invoice",
    "contracts.firstDate": "First invoice date",
    "contracts.interval": "Interval (months)",
    "contracts.forms": "Contract Documents",
    "contracts.email": "Send via Email",
    "contracts.contractDoc": "Service Agreement",
    "contracts.parties": "Parties",
    "contracts.object": "Scope of Services",
    "contracts.provider": "The Professional / The Company",
    "contracts.theClient": "The Client",
    "svc.new": "New Service",
    "svc.category": "Category",
    "svc.price": "Unit Price",
    "svc.currency": "Currency",
    "svc.select": "Select Services from Price List",
    "svc.selectedTotal": "Selected Total",
    "svc.empty": "No articles yet: add them from the Articles page",
    "cat.trust": "Trust Articles",
    "cat.societa_estere": "Foreign Companies Articles",
    "cat.consulenza": "Consulting Articles",
    "cat.consulenza_trust": "Trust Consulting Articles",
    "cat.consulenza_aziendale": "Business Consulting Articles",
    "cat.marchi_brevetti": "Trademarks & Patents Articles",
    "cat.societa_innovative": "Innovative Companies Articles",
    "cat.consulenza_trustee": "Trustee Consulting Articles",
    "svc.seedTrust": "Load Trust Catalog (17 jurisdictions)",
    "svc.seeded": "trust sheets loaded into the price list",
    "svc.alreadySeeded": "Trust catalog already loaded",
    "aml.formTitle": "Customer Due Diligence Form — AML",
    "privacy.formTitle": "Privacy Notice — Art. 13 GDPR",
    "contacts.recipientCode": "SDI Recipient Code",
    "aml.title": "Anti-Money Laundering (AML/KYC)",
    "aml.new": "New Check",
    "aml.subject": "Subject",
    "aml.risk": "Risk Level",
    "aml.low": "Low",
    "aml.medium": "Medium",
    "aml.high": "High",
    "aml.owner": "Beneficial Owner",
    "aml.checkDate": "Check Date",
    "aml.pending": "Pending",
    "aml.verified": "Verified",
    "aml.expiredV": "Expired",
    "privacy.title": "GDPR Processing Register",
    "privacy.new": "New Processing Activity",
    "privacy.treatment": "Processing",
    "privacy.purpose": "Purpose",
    "privacy.legalBasis": "Legal Basis",
    "privacy.categories": "Data Categories",
    "privacy.retention": "Retention",
    "vault.title": "Identity Document Vault",
    "vault.upload": "Upload Document",
    "vault.subject": "Holder",
    "vault.docType": "Document Type",
    "vault.identity": "ID Card",
    "vault.passport": "Passport",
    "vault.taxcode": "Tax Code",
    "vault.other": "Other",
    "vault.search": "Search documents…",
    "vault.expiry": "Expiry date",
    "vault.edit": "Edit document",
    "vault.visura": "Chamber of Commerce extract",
    "vault.durc": "DURC",
    "vault.contract": "Contract",
    "ledger.accounts": "Chart of Accounts",
    "ledger.journal": "Journal (Double-Entry)",
    "ledger.new": "New Entry",
    "ledger.code": "Code",
    "ledger.debit": "Debit",
    "ledger.credit": "Credit",
    "ledger.account": "Account",
    "ord.badge": "Ordinary accounting",
    "ord.subtitle": "Double-entry with customizable journal templates, open items, account ledgers and trial balance.",
    "ord.tab.journal": "Journal",
    "ord.tab.open": "Open items",
    "ord.tab.causali": "Templates",
    "ord.tab.accounts": "Chart of accounts",
    "ord.tab.trial": "Trial balance",
    "ord.newEntry": "New entry",
    "ord.causale": "Template",
    "ord.pickCausale": "Pick a template…",
    "ord.amountTotal": "Total amount (VAT incl.)",
    "ord.amountNet": "Net amount",
    "ord.vatRate": "VAT rate",
    "ord.docRef": "Document reference",
    "ord.contact": "Client / Supplier",
    "ord.net": "Net",
    "ord.vat": "VAT",
    "ord.total": "Total",
    "ord.addLine": "Add line",
    "ord.unbalanced": "Entry not balanced",
    "ord.balanced": "Balanced",
    "ord.searchJournal": "Search journal…",
    "ord.ref.invoice": "Invoice",
    "ord.ref.payment": "Payment",
    "ord.ref.settlement": "Settlement",
    "ord.ref.manual": "Manual",
    "ord.ref.causale": "Template",
    "ord.ref.credit_note": "Credit note",
    "ord.ref.self_invoice": "Self-invoice",
    "ord.ref.expense_report": "Expense report",
    "ord.ref.vat_liquidation": "VAT settl.",
    "common.edit": "Edit",
    "ord.causaliHint": "Templates pre-fill the double-entry posting: edit them or create your own.",
    "ord.newCausale": "New template",
    "ord.editCausale": "Edit template",
    "ord.groupLbl": "Group",
    "ord.baseLbl": "Amount entered",
    "ord.register": "VAT register",
    "ord.noVat": "No VAT",
    "ord.causaleLines": "Posting lines",
    "ord.group.vendite": "Sales",
    "ord.group.acquisti": "Purchases",
    "ord.group.finanza": "Cash & bank",
    "ord.group.spese": "Expense reports",
    "ord.group.personale": "Staff",
    "ord.group.iva": "VAT",
    "ord.group.altro": "Other",
    "ord.amt.total": "Total",
    "ord.amt.net": "Net",
    "ord.amt.vat": "VAT",
    "ord.amt.manual": "Manual",
    "ord.receivables": "Receivables",
    "ord.payables": "Payables",
    "ord.residual": "Residual",
    "ord.settle": "Record receipt/payment",
    "ord.confirmSettle": "Confirm posting",
    "ord.settledOk": "Items settled and entry posted",
    "ord.mixedKinds": "Select only receivables or only payables for one posting.",
    "ord.finAccount": "Cash/bank account",
    "ord.autoDesc": "Automatic if empty",
    "ord.searchAccount": "Search account…",
    "ord.newAccount": "New account",
    "ord.editAccount": "Edit account",
    "ord.mastrino": "Account ledger",
    "ord.balance": "Balance",
    "ord.balanceDebit": "Debit balance",
    "ord.balanceCredit": "Credit balance",
    "ord.trialHint": "Sum of all debit and credit movements per account: totals must match.",
    "ord.type.asset": "Asset",
    "ord.type.liability": "Liability",
    "ord.type.equity": "Equity",
    "ord.type.revenue": "Revenue",
    "ord.type.expense": "Expense",
    "inv.number": "Number",
    "rep.ce": "Profit & Loss",
    "rep.sp": "Balance Sheet",
    "rep.vat": "VAT Registers",
    "rep.uk": "UK Balance Sheet",
    "rep.export": "Accountant Export",
    "rep.revenues": "Revenues",
    "rep.expenses": "Expenses",
    "rep.result": "Net Result",
    "rep.assets": "Assets",
    "rep.liabilities": "Liabilities",
    "rep.equity": "Equity",
    "rep.salesReg": "Sales VAT Register",
    "rep.purchReg": "Purchases VAT Register",
    "rep.from": "From",
    "rep.to": "To",
    "rep.protocol": "Prot.",
    "rep.exportDesc": "Download the CSV file with all double-entry records to hand to your external accountant.",
    "uk.title": "Balance Sheet (FRS 102 format)",
    "uk.turnover": "Turnover",
    "uk.admin": "Administrative expenses",
    "uk.fixedAssets": "Fixed assets",
    "uk.currentAssets": "Current assets",
    "uk.creditors": "Creditors: amounts falling due within one year",
    "uk.netAssets": "Net assets",
    "uk.capital": "Capital and reserves",
    "uk.profit": "Profit for the financial year",
    "cf.forecast": "Collections & Payments Forecast",
    "cf.actual": "Actual Movements",
    "cf.month": "Month",
    "msg.saved": "Saved successfully",
    "msg.deleted": "Deleted",
    "msg.error": "Operation failed",
    "msg.extractFail": "AI extraction failed, please enter data manually",
  },
};

export default dict;
